G.GingyCharacterTutorial = function () {
  Phaser.Group.call(this, game);
  this.position.setTo(
    G.OMTsettings.elements.gingy.mugshot.x,
    G.OMTsettings.elements.gingy.mugshot.y
  );

  this.gingy = game.add.group(this);

  // this.backEyes = G.makeImage(G.OMTsettings.elements.gingy.backEyes.x, G.OMTsettings.elements.gingy.backEyes.y, 'gingy_eyes_back', 0.5, this.gingy);
  this.eyes = G.makeImage(G.OMTsettings.elements.gingy.eyes.x, G.OMTsettings.elements.gingy.eyes.y, 'gingy_eyes', 0.5, this.gingy);
  this.body = G.makeImage(0, 0, 'gingy_body', [0.5, 207 / 228], this.gingy);
  this.eyelids = G.makeImage(G.OMTsettings.elements.gingy.eyelids.x, G.OMTsettings.elements.gingy.eyelids.y, 'gingy_eyelids', 0.5, this.gingy);
  this.eyelids.visible = false;
  this.mouth = G.makeImage(G.OMTsettings.elements.gingy.mouth.x, G.OMTsettings.elements.gingy.mouth.y, 'gingy_mouth_closed', 0.5, this.gingy);

  this.gingy.scale.x = this.gingy.scale.y = G.OMTsettings.global.jungleMatch ? 0.85 : 1.0;
  this.gingy.x = G.OMTsettings.elements.gingy.body.x || 0;
  this.gingy.y = G.OMTsettings.elements.gingy.body.y || 0;

  this.breathingTween = game.add.tween(this.gingy.scale)
    .to({ y: G.OMTsettings.global.jungleMatch ? 0.86 : 1.01 }, 1200, Phaser.Easing.Sinusoidal.InOut, true, 0, -1, true);

  this.lookAtTween = null;

  this.blinkingTween = game.add.tween(this)
    .to(null, 2500, Phaser.Easing.Linear.None, true, 0, -1);
  this.blinkingTween.onUpdateCallback(function (tween, progress) {
    this.eyelids.visible = (progress > 0.75 && progress < 0.8) || (progress > 0.95);
  }, this);

  this.gingyTalkingTween = game.add.tween(this)
    .to(null, 150, Phaser.Easing.Linear.None, true, 0, -1);
  this.gingyTalkingTween.onLoop.add(function () {
    if (this.mouth.cache === null) return;
    const textures = [
      'gingy_mouth_closed',
      'gingy_mouth_open',
      'gingy_mouth_surprised',
    ];
    textures.splice(textures.indexOf(this.mouth.frameName), 1);
    // console.log(textures.splice(textures.indexOf(this.mouth.frameName), 1));

    this.mouth.changeTexture(game.rnd.pick(textures));
  }, this);

  this.idle();
  // .onUpdateCallback(function(tween, progress) {
  //   this.mouth.changeTexture(talk[Math.floor((talk.length*progress))]);
  // }, this);

  this.onDestroy.add(function () {
    this.blinkingTween.stop();
    this.gingyTalkingTween.stop();
    this.gingyTalkingTween.stop();
  }, this);
};

G.GingyCharacterTutorial.prototype = Object.create(Phaser.Group.prototype);

G.GingyCharacterTutorial.prototype.talk = function () {
  this.blinkingTween.resume();
  this.gingyTalkingTween.resume();
};

G.GingyCharacterTutorial.prototype.idle = function () {
  this.blinkingTween.resume();
  this.gingyTalkingTween.pause();
  this.mouth.changeTexture('gingy_mouth_closed');
};

G.GingyCharacterTutorial.prototype.smile = function () {
  this.blinkingTween.pause();
  this.eyelids.visible = true;
  this.gingyTalkingTween.pause();
  this.mouth.changeTexture('gingy_mouth_closed');
};

G.GingyCharacterTutorial.prototype.lookAt = function (obj) {
  if (!obj) return;
  const normX = obj.x;
  const normY = obj.y;

  if (this.lookAtTween) this.lookAtTween.stop();
  this.lookAtTween = game.add.tween(this.eyes.pivot)
    .to({ x: normX * -7, y: normY * -7 }, 500, Phaser.Easing.Sinusoidal.Out, true);
};
